import { SelectionModel } from '@angular/cdk/collections';
import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FilterParams } from '../../models/filter-params';
import { FilterHeaderComponent } from '../filter-header/range-date-filter.component';
import { SpinnerComponent } from '../spinner/spinner.component';

export type Option = {
  id: string | number;
  title: string;
  content?: string;
};

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-select-items-filter',
  standalone: true,
  imports: [
    CommonModule,
    ScrollingModule,
    MatToolbarModule,
    MatListModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCheckboxModule,
    OverlayModule,
    FilterHeaderComponent,
    SpinnerComponent,
    ScrollingModule,
  ],
  templateUrl: './select-items-filter.component.html',
  styleUrls: ['./select-items-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectItemsFilterComponent implements OnInit {
  isOpen = false;
  selection = new SelectionModel<Option>(true, []);
  @Input() listItems: Option[] | null = null;
  @Input({ required: true }) propFilter = 'filter';
  @Input({ required: true }) title = 'Title';
  @Input({ required: true }) itemSize = 50;
  @Input() showSelectAllOption = true;
  @Input() singleSelection = false;
  @Input() returnValuesAsArray = true;
  @Input() initialSelection: Option[] = [];
  @Output() filterChanged = new EventEmitter<FilterParams>();

  ngOnInit(): void {
    if (this.singleSelection) {
      this.selection = new SelectionModel<Option>(
        false,
        this.initialSelection,
        true,
        this._compareById
      );
    } else {
      this.selection = new SelectionModel<Option>(
        true,
        this.initialSelection,
        true,
        this._compareById
      );
    }
  }

  close() {
    this.isOpen = false;
  }

  clear() {
    this.close();
    this.clearSelections();
    this._emitSelectionChanged();
  }

  applyFilter(): void {
    this._emitSelectionChanged();
  }

  toogleOpen(open: boolean) {
    this.isOpen = open;
  }

  get allSelected() {
    return (
      this.listItems &&
      !!this.listItems.length &&
      this.selection.selected.length > 0 &&
      this.selection.selected.length == this.listItems.length
    );
  }

  toggleMasterSelection() {
    if (this.allSelected) {
      this.clearSelections();
    } else {
      this.selectAll();
    }
  }

  toogleItem(item: Option) {
    this.selection.toggle(item);
    this.applyFilter();
  }
  selectAll() {
    this.selection.select(...(this.listItems ?? []));
    this.applyFilter();
  }

  clearSelections() {
    this.selection.clear();
  }

  _emitSelectionChanged() {
    const filterParams: FilterParams = {};
    if (this.returnValuesAsArray) {
      filterParams[this.propFilter] = this.selection.selected.map(
        (option) => option.id
      );
    } else {
      filterParams[this.propFilter] = this.selection.selected
        .map((option) => option.id)
        .join(',');
    }
    this.filterChanged.emit(filterParams);
  }

  private _compareById(a: Option, b: Option) {
    return a.id === b.id;
  }
}
